module.exports = __webpack_public_path__ + "static/media/xata-brand.b5870747.svg";